import utils from '@/mixins/utils';

export default {
  mixins: [utils],
  methods: {
    copyAnalytic(analytic) {
      return {
        uuid: analytic.uuid,
        actions: analytic.actions,
        categories: analytic.categories,
        context: analytic.context,
        tags: analytic.tags,
        description: analytic.description,
        filter: analytic.filter,
        inputType: analytic.inputType,
        level: analytic.level,
        name: analytic.name,
        snapshotFiles: analytic.snapshotFiles,
        released: analytic.released,
      };
    },
    generateInternalAnalytic(analytic, admin) {
      const internalAnalytic = {
        uuid: analytic.uuid,
        actions: analytic.actions,
        categories: analytic.categories,
        context: [],
        tags: analytic.tags,
        description: analytic.description,
        filter: analytic.filter,
        inputType: analytic.inputType,
        level: analytic.level,
        name: analytic.name,
        snapshotFiles: [],
      };

      analytic.snapshotFiles.forEach((f) => {
        internalAnalytic.snapshotFiles.push({
          key: this.uuid(),
          value: f,
        });
      });

      analytic.context.forEach((c) => {
        internalAnalytic.context.push({
          key: this.uuid(),
          name: c.name,
          type: c.type,
          exprs: c.exprs,
        });
      });

      if (admin) {
        internalAnalytic.released = analytic.released;
      }
      return internalAnalytic;
    },
  },
};
